// extracted by mini-css-extract-plugin
module.exports = {"disabledLink":"styles_disabledLink__1RC4X"};